import * as React from 'react';
import './index.css';
import i18nClient from '@/src/pages/market/my_coupon_list/locales/i18n.config';
import { splitText } from '@/src/pages/market/components/utils';
import { CouponSubCategory } from '@/src/pages/market/constants/CouponConstant';

const BackPressModule = Mach.requireModule('BackPressModule');

interface Props {
  onClickCloseBtn?: Function;
  dialogInfo?: object;
}

/**
 * 我的券列表-规则弹窗
 */
export default class MyCouponRuleDialog extends React.Component<Props, any> {
  backPressModuleId;

  constructor(props) {
    super(props);
    Mach.on('pageDidDisappear', () => {
    });
    this.backPressModuleId = BackPressModule?.addBackPressListener(() => true
      //return true;  // 返回true时会阻止事件冒泡传递，因而不会执行默认的后退行为
      //return false; // 返回false时会使事件继续传递，触发其他注册的监听函数，或是系统默认的后退行为
    );
  }

  componentWillUnmount() {
    if (this.backPressModuleId) {
      BackPressModule?.removeBackPressListener(this.backPressModuleId);
    }
  }

  /**
     * 校验时间
     */
  isCurrentTimes = () => {
    const getTime = () => new Date().valueOf();
    const { couponBaseInfoDto } = this.props.dialogInfo;
    return getTime() > couponBaseInfoDto?.startTime;
  }

  /**
     * 关闭按钮点击
     */
  onClickCloseBtn = () => {
    const { onClickCloseBtn } = this.props;
    // @ts-ignore
    onClickCloseBtn && onClickCloseBtn();
  };

  /**
     * 消费点击事件
     */
  onClickNull = () => {
    //
  };

  render() {
    // i18n
    const dialogTitle = i18nClient.getText('coupon_list_useable_rule_title');
    const buttonText = i18nClient.getText('coupon_list_useable_rule_bottom_button');
    // 数据处理
    const { couponDisplayInfoDto, couponBaseInfoDto } = this.props.dialogInfo;
    const SLMPI18N = Mach.requireModule('Intl');
    const currentLocale = SLMPI18N?.getCurrentLocaleInfo().locale === 'en';
    const ruleListLastIndex = couponDisplayInfoDto?.useRuleDocList?.length - 1; // 最后一条规则
    // 判断券类型
    const isFreeCoupon = couponBaseInfoDto?.subCategory === CouponSubCategory.free_coupon;
    const isAllotmentCoupon = couponBaseInfoDto?.subCategory === CouponSubCategory.allotment_coupon;
    const isCommonCoupon = !isFreeCoupon && !isAllotmentCoupon;

    return (
      <view className="dialog-mask" onClick={this.onClickCloseBtn}>
        <view className="dialog-container content-animation" onClick={this.onClickNull}>

          {/*右上角背景图*/}
          <image className="rule-bg-image" src={couponDisplayInfoDto?.couponBackgroundInfo?.useRulePopupCouponAmountBackgroundUrl} />

          {/*标题*/}
          <text className="dialog-title" content={dialogTitle} />

          {/*金额区*/}
          <view className="common-coupon-amount-wapper">

            {/*免配券*/}
            {isFreeCoupon && (
              <view className="free-coupon-text-wapper">
                <text className="free-coupon-text" content={couponDisplayInfoDto?.couponAmountText} />
              </view>
            )}

            {/*普通券*/}
            {isCommonCoupon && (
              <view className="common-coupon-left-wapper">
                <text className="common-coupon-dollar-text" content={couponDisplayInfoDto?.currencyType} />
                <text className="free-coupon-text" content={couponDisplayInfoDto?.couponAmountString} />
                {currentLocale && <text className="common-coupon-unit-text" content="off" />}
              </view>
            )}

            {/*减配券*/}
            {isAllotmentCoupon && (
              <view className="allotment-coupon-left-wapper">
                <view className="common-coupon-left-wapper">
                  <text
                    className="common-coupon-dollar-text"
                    content={couponDisplayInfoDto?.currencyType}
                  />
                  <text className="free-coupon-text" content={couponDisplayInfoDto?.couponAmountString} />
                  {currentLocale && <text className="common-coupon-unit-text" content="off" />}
                </view>
                <view className="allotment-coupon-text-wapper">
                  {splitText(couponDisplayInfoDto?.shortDescription).map((item) => (
                    <text className="allotment-coupon-text" content={item} />
                  ))}
                </view>
              </view>
            )}
          </view>

          {/*券信息区*/}
          <view className="common-coupon-info-wapper">
            <view className="coupon-info-wapper">
              {couponDisplayInfoDto?.name
                            && <text className="coupon-zero-limit-text">{couponDisplayInfoDto?.name}</text>}
              {couponDisplayInfoDto?.sillAmountText
                            && <text className="coupon-first-limit-text">{couponDisplayInfoDto?.sillAmountText}</text>}
              {couponDisplayInfoDto?.shortUseRuleDoc
                            && <text className="coupon-second-limit-text">{couponDisplayInfoDto?.shortUseRuleDoc}</text>}
              {couponDisplayInfoDto?.validTimeText && (
                <text
                  className="coupon-valid-text"
                  style={(this.isCurrentTimes() && [1, 2, 3].includes(couponDisplayInfoDto?.expiredDays ? parseInt(couponDisplayInfoDto?.expiredDays) : 0)) ? { color: '#D90012' } : { color: '#808080' }}
                >{couponDisplayInfoDto?.validTimeText}</text>
              )}
            </view>
          </view>

          {/*分割线*/}
          <view className="divide-line-wrap">
            <view className="divide-line" />
          </view>

          {/*规则区*/}
          {couponDisplayInfoDto?.useRuleDocList && (
            <view className="common-coupon-rule-content">
              <scroller className="common-coupon-rule-wapper" showScrollIndicator={false}>
                <content>
                  {couponDisplayInfoDto?.useRuleDocList
                                && couponDisplayInfoDto?.useRuleDocList.map((item: any, index: number) => (
                                  <view className="bottom-bottom-wapper" style={{ marginBottom: index === ruleListLastIndex ? 16 : 0, marginTop: index === 0 ? 10 : 0 }}>
                                    <text className="rule-use-limit-text-dot" />
                                    <text className="rule-use-limit-text">{item}</text>
                                  </view>
                                ))}
                </content>
              </scroller>
            </view>
          )}

          {/*分割线2*/}
          <view className="divide-line-wrap-btn">
            <view className="divide-line-btn" />
          </view>

          {/*底部按钮*/}
          <view className="dialog-button-container" style={{ 'min-height': Mach.env.safeAreaInsets.bottom + 62 }}>
            <text className="dialog-button" content={buttonText} onClick={this.onClickCloseBtn} />
          </view>
        </view>
      </view>
    );
  }
}
